/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PixPaymentAttempt } from './pixPaymentAttempt';
import { SubscriberBillingHistoryEdition } from './subscriberBillingHistoryEdition';

export interface SubscriberPaymentDetail {
  amount?: number;
  attempts?: Array<PixPaymentAttempt>;
  authorizationCode?: string;
  authorizationMessage?: string;
  billings?: Array<SubscriberBillingHistoryEdition>;
  creditCardId?: number;
  creditCardPaymentTypeId?: number;
  dateAuthorized?: Date;
  dateCreated?: Date;
  dateExpired?: Date;
  gatewayId?: number;
  gatewayName?: string;
  installments?: number;
  nextStep?: string;
  paymentGuid?: string;
  paymentId?: number;
  paymentType?: string;
  paymentTypeName?: string;
  subscriberId?: number;
  subscriberPendingFeeId?: number;
  subscriptionTypeId?: number;
  transactionId?: string;
  transactionStatusId?: number;
  transactionStatusName?: string;
}
